import React, { Component } from 'react';
import { IoGlassesSharp } from 'react-icons/all';
import store from '../../../../store';
import { executeEvent } from '../../../360tour/action';


export default class VRTool extends Component {
    constructor() {
        super();
        this.state = {
            toggleDetail: false
        }
    }

    goVR() {
        store.dispatch(executeEvent((krpano) => {
            krpano.call("webvr.enterVR()");
        }));
    }

    getIconView(){
        if(window.config.toolbar?.vr?.icon != null)
            return <img src={`${process.env.PUBLIC_URL}/data/${window.config.toolbar?.vr?.icon}`} />
        return  <IoGlassesSharp />
    }

    render() {
        if (!window.config.toolbar?.vr?.display) return;
        return (
            <div className="tool-item" id="tool-vr">
                <div className="item-icon" onClick={this.goVR.bind(this)}>
                   {this.getIconView.call(this)}
                </div>
                {
                    this.state.toggleDetail ? this.getInfoPanelView.call(this) : null
                }
            </div>
        )
    }
}
